module.exports = __webpack_public_path__ + "Flaticon.6cb58f09a021f34395ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/global-css/fonts/font/Flaticon.svg
// module id = ./src/app/global-css/fonts/font/Flaticon.svg
// module chunks = main